export default __webpack_public_path__ + "static/media/slider3.b43a1174.png";